import { Lozenge, LozengeAppearance } from '@/libraries/design/components/lozenge/src/lozenge';

export type UniformLozengeProps = {
	text: string;
	color?: 'blue' | 'neutral' | 'saffron' | 'lime' | 'purple' | 'red';
};

export const UniformLozenge = (props: UniformLozengeProps) => {
	const appearance: LozengeAppearance = props.color === 'red' ? 'danger' : props.color || 'neutral';

	return <Lozenge appearance={appearance} text={props.text} />;
};

export default UniformLozenge;
